import React, { memo } from 'react';

//Function
const TopBar = () => {
    return (
        <>
            <section className="top-bar">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 poppins-regular">
                            <ul className="text-right">
                                <li>
                                    <a href="tel:+919716699992">
                                        <img src={`${process.env.PUBLIC_URL}/images/phone-call-1.png`} alt="" /> 
                                        Call us 9716699992
                                    </a>
                                </li>
                                <li>
                                    <a href="mailto:info@goptindia.com">
                                        <img src={`${process.env.PUBLIC_URL}/images/email-icon.png`} alt="" /> 
                                        info@goptindia.com
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default memo(TopBar);
